import { render, staticRenderFns } from "./EstructuraComercialPantalla.vue?vue&type=template&id=5b61f311&"
import script from "./EstructuraComercialPantalla.vue?vue&type=script&lang=ts&"
export * from "./EstructuraComercialPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5b61f311', component.options)
    } else {
      api.reload('5b61f311', component.options)
    }
    module.hot.accept("./EstructuraComercialPantalla.vue?vue&type=template&id=5b61f311&", function () {
      api.rerender('5b61f311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorEstructuraCom/EstructuraComercialPantalla.vue"
export default component.exports